import AccountReducer from "./slice/AccountReducer";
import {combineReducers} from "redux";
import CacheReducer from "./slice/CacheReducer";
import TemporaryReducer from "./slice/TemporaryReducer";

const reducers = combineReducers({
    account_reducer: AccountReducer,
    cache_reducer: CacheReducer,
    temporary_reducer: TemporaryReducer,
})
export default reducers